"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainSettlement = mapToDomainSettlement;
exports.mapToDomainSettlementDetails = mapToDomainSettlementDetails;
function mapToDomainSettlement(dto) {
    return {
        id: dto.id,
        settlementNumber: dto.settlementNumber,
        clubId: dto.clubId,
        clubName: dto.clubName,
        machineId: dto.machineId,
        machineName: dto.machineName,
        billingPeriod: dto.billingPeriod,
        netPayout: dto.netPayout,
        issueDate: dto.issueDate,
    };
}
function mapToDomainSettlementDetails(dto) {
    return {
        id: dto.id,
        settlementNumber: dto.settlementNumber,
        issuer: dto.issuer,
        club: dto.club,
        createDate: dto.createDate,
        billingPeriod: dto.billingPeriod,
        lineItems: dto.lineItems,
        vatDetails: dto.vatDetails.map(mapToDomainVatDetails),
        totalTaxBase: dto.totalTaxBase,
        grossAmount: dto.grossAmount,
        currency: dto.currency,
    };
}
function mapToDomainVatDetails(dto) {
    return {
        vatPercent: dto.vatPercent,
        taxBase: dto.taxBase,
        vatAmount: dto.vatAmount,
    };
}
